<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import com from '../../../../../../comMapping.js';
export default {
	props: {
		ExcisePayerTk: {
			type: Boolean,
			default: false
		},
		consumptionPayerTypeList: []
	},
	data() {
		return { comMapping: com };
	},
	mounted() {},
	created() {},
	methods: {
		ExcisePayerTkclosediag() {
			this.$emit('ExcisePayerTkclosediag', false);
		},
		forRouter() {},
		//时间撮转时间
		timestampToTimesfm(timestamp) {
			if (timestamp) {
				// 时间戳为10位需*1000，时间戳为13位不需乘1000
				var date = new Date(timestamp);
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '-';
				var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + ' ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				// return Y + M + D + h + m + s;
				return Y + M + D;
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
